import { isArray, isObject } from '@jd/jmtd-tools/es/is';
export function isObjectEqual(prev, current) {
  if (prev === current) {
    return true;
  }

  if (!isObject(prev)) {
    return false;
  }

  var prevKeySet = new Set(Object.keys(prev));

  for (var key in current) {
    if (Object.prototype.hasOwnProperty.call(current, key)) {
      if (prev[key] !== current[key]) {
        return false;
      }

      prevKeySet.delete(key);
    }
  }

  return prevKeySet.size === 0;
}
export function isArrayEqual(prev, current) {
  if (prev === current) {
    return true;
  }

  if (!isArray(prev)) {
    return false;
  }

  if (prev.length !== current.length) {
    return false;
  }

  for (var i = 0, len = current.length; i !== len; ++i) {
    if (prev[i] !== current[i]) {
      return false;
    }
  }

  return true;
}
export function isPropsEqual(prev, current) {
  var shallow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var shallowSet = new Set(shallow);
  var prevKeySet = new Set(Object.keys(prev));

  for (var key in current) {
    if (Object.prototype.hasOwnProperty.call(current, key)) {
      var curField = current[key];
      var prevField = prev[key];

      if (shallowSet.has(key)) {
        // 浅比较字段
        if (curField !== prevField) {
          return false;
        }
      } else if (isObject(curField)) {
        // 对象字段
        if (!isObjectEqual(prevField, curField)) {
          return false;
        }
      } else if (isArray(curField)) {
        // 数组字段
        if (!isArrayEqual(prevField, curField)) {
          return false;
        }
      } else if (curField !== prevField) {
        return false;
      }

      prevKeySet.delete(key);
    }
  }

  return prevKeySet.size === 0;
}